import { Calendar } from 'fullcalendar';
import classicThemePlugin from 'fullcalendar/themes/classic';
import interactionPlugin from 'fullcalendar/interaction';

import 'fullcalendar/skeleton.css';
import 'fullcalendar/themes/classic/theme.css';
import 'fullcalendar/themes/classic/palette.css';

const fullcalendar = {
  install(Vue) {
    const init = (el, options = {}) => {
      const { plugins = [], ...rest } = options;
      const calendar = new Calendar(el, {
        ...rest,
        plugins: [
          classicThemePlugin,
          interactionPlugin,
          ...plugins,
        ],
      });
      calendar.render();
      return calendar;
    };

    const widget = {
      init,
    };

    Vue.prototype.$fullcalendar = widget;
    Vue.fullcalendar = widget;
  },
};

export default fullcalendar;
